export default __webpack_public_path__ + "static/media/GR00014-sciences_card_1.8af44fce.svg";